var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 89,
    viewBox: "0 0 87 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5459 79.8294V56.3047",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8867 79.8295V68.1641",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0642 60.1612C75.0642 60.1612 73.3922 59.9423 72.7067 58.4206C72.0212 56.8988 71.9559 52.9735 74.5601 48.6229C77.1643 44.2724 78.5298 44.2265 78.9832 47.7766C79.4366 51.3267 79.3713 56.4819 78.3049 58.4352C77.2386 60.3884 75.0642 60.1612 75.0642 60.1612Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6582 51.9668C75.9665 50.7578 76.3346 49.6738 76.7626 48.9316",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3623 59.9002C74.5917 57.5077 74.9552 55.1347 75.4504 52.7959",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0599 67.7976C76.0599 67.7976 74.9863 66.8408 75.0734 65.465C75.1604 64.0891 76.5387 61.3479 79.9136 59.6093C83.2885 57.8708 84.2514 58.4878 83.2721 61.1519C82.2929 63.816 80.3706 67.3411 78.9198 68.175C77.469 69.0088 76.0599 67.7976 76.0599 67.7976Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4541 62.4314C80.107 61.7476 80.7562 61.1806 81.3202 60.8721",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0198 62.9023C77.8253 64.2773 76.7095 65.7395 75.6793 67.28C75.6793 67.28 74.8143 68.6183 74.5586 71.2762",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4511 75.7433C75.4511 75.7433 74.8291 75.1888 74.8799 74.3925C74.9307 73.5961 75.7286 72.0077 77.6854 70.9987C79.6421 69.9898 80.197 70.3504 79.6294 71.8951C79.0618 73.4398 77.9483 75.4806 77.1105 75.9622C76.2727 76.4437 75.4511 75.7433 75.4511 75.7433Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4121 72.6438C77.7355 72.2849 78.1019 71.9809 78.5002 71.7412",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1602 72.917C76.4685 73.7125 75.8221 74.5585 75.2253 75.4498C75.2253 75.4498 74.7229 76.2253 74.5742 77.7658",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.03 64.616C73.03 64.616 74.1017 63.6592 74.0165 62.2833C73.9313 60.9075 72.5512 58.1662 69.1745 56.4277C65.7978 54.6891 64.8385 55.3062 65.8177 57.9703C66.797 60.6344 68.7193 64.1595 70.1701 64.9933C71.6209 65.8272 73.03 64.616 73.03 64.616Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6364 59.2507C69.0806 58.6327 68.4518 58.1077 67.7686 57.6914",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0703 59.7207C71.2639 61.0959 72.3791 62.5581 73.4089 64.0984C73.4089 64.0984 74.274 65.4367 74.5315 68.0946",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5025 75.241C72.5025 75.241 73.5905 75.2807 74.1346 74.5281C74.6786 73.7756 75.0051 71.6743 73.645 69.1081C72.2848 66.542 71.4162 66.3627 70.8721 68.2389C70.3281 70.115 70.0107 72.8646 70.5548 74.0132C71.0988 75.1618 72.5025 75.241 72.5025 75.241Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6729 73.3271C72.6894 73.5836 72.7005 73.84 72.706 74.0943",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8389 68.1162C72.2087 69.6271 72.4719 71.1699 72.6259 72.7294",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3457 60.0463H27.4462V1.15625",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0829 60.0463H28.9824V1.15625",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2275 60.0463H64.328V1.15625",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2063 14.9834L50.4326 26.1277",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.339 23.6055L51.9053 26.6969",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 12.0566L30.2617 18.0749",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2832 10.5915L39.4858 6.52441",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4215 47.8447L23.3477 51.7492",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3971 42.6396L19.6973 49.8795",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2122 19.8519C85.0749 14.496 82.8077 8.41852 78.1484 6.27741C73.4891 4.1363 68.2021 6.74238 66.3394 12.0982C64.4768 17.4541 66.7439 23.5316 71.4032 25.6727C76.0625 27.8138 81.3496 25.2078 83.2122 19.8519Z",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.779 25.0933C79.1588 25.0933 82.7094 21.0119 82.7094 15.9773C82.7094 10.9427 79.1588 6.86133 74.779 6.86133C70.3992 6.86133 66.8486 10.9427 66.8486 15.9773C66.8486 21.0119 70.3992 25.0933 74.779 25.0933Z",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7786 16.6011C75.078 16.6011 75.3208 16.322 75.3208 15.9778C75.3208 15.6336 75.078 15.3545 74.7786 15.3545C74.4791 15.3545 74.2363 15.6336 74.2363 15.9778C74.2363 16.322 74.4791 16.6011 74.7786 16.6011Z",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7793 16.6006V19.6629",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2374 15.9775H67.7705",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5174 41.1838L30.5287 35.8514C32.3498 32.4673 32.9672 28.407 32.2526 24.5135C31.538 20.62 29.5463 17.1925 26.6912 14.9425C23.836 12.6925 20.3367 11.7929 16.9197 12.4305C13.5028 13.0682 10.4307 15.1941 8.34143 18.3668C6.25211 21.5395 5.30606 25.5153 5.69968 29.4687C6.0933 33.4221 7.79636 37.0494 10.4553 39.5974C13.1142 42.1455 16.5246 43.4185 19.9786 43.1522C23.4325 42.8859 26.6645 41.1008 29.0036 38.1674L33.5174 41.1838Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8022 39.8872L30.8117 34.5548C32.6295 31.1722 33.2443 27.1148 32.5282 23.225C31.8122 19.3352 29.8204 15.9118 26.9664 13.6656C24.1125 11.4194 20.6155 10.5229 17.2017 11.1623C13.7879 11.8017 10.7194 13.9279 8.6334 17.0994C6.54738 20.2708 5.60406 24.244 5.9993 28.1939C6.39454 32.1438 8.09796 35.767 10.7559 38.3113C13.4139 40.8555 16.8221 42.1253 20.2731 41.8571C23.7241 41.5889 26.9526 39.8032 29.2884 36.8708L33.8022 39.8872Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91858 28.6301V27.1855L11.9787 23.5457C12.1347 23.2768 12.2816 23.0142 12.4212 22.7619C12.5555 22.5176 12.6697 22.2594 12.7621 21.9906C12.8509 21.7289 12.8959 21.4502 12.8945 21.1693C12.9098 20.944 12.8573 20.7196 12.7458 20.5335C12.6969 20.4653 12.635 20.4109 12.5649 20.3748C12.4947 20.3386 12.4182 20.3216 12.3414 20.325C12.2599 20.3197 12.1782 20.3331 12.1013 20.3646C12.0243 20.3961 11.9537 20.445 11.8935 20.5085C11.7808 20.6438 11.7051 20.8141 11.6759 20.9984C11.6341 21.2238 11.614 21.4537 11.616 21.6842V22.1678H9.89682V21.6425C9.89047 21.1095 9.9736 20.5801 10.1416 20.0832C10.2949 19.6349 10.5671 19.2534 10.9196 18.993C11.341 18.7075 11.8256 18.5692 12.3142 18.5948C13.0892 18.5948 13.6731 18.8255 14.066 19.2869C14.4589 19.7483 14.656 20.391 14.6572 21.2152C14.6605 21.5952 14.6046 21.9729 14.4922 22.3304C14.3788 22.68 14.2322 23.0142 14.0551 23.3269C13.8738 23.65 13.6816 23.9856 13.4748 24.3379L11.8989 27.0479H14.4233V28.6301H9.91858Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7039 28.6308V26.4107H15.0508V24.9056L17.2995 18.7227H19.3651V24.8931H20.163V26.4107H19.3651V28.6308H17.7039ZM16.4036 24.8785H17.7039V20.7677L16.4036 24.8785Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8242 28.6303L23.4647 18.7139H24.4022L21.7509 28.6303H20.8242Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5517 28.6303L27.4269 20.269H25.0693V18.7139H29.1587V20.121L27.289 28.6303H25.5517Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5928 34.9843C11.3814 34.9934 11.172 34.9334 10.9889 34.8113C10.8279 34.6946 10.7014 34.5245 10.6262 34.3235C10.5403 34.0906 10.4899 33.8424 10.4775 33.5897L10.8402 33.4647C10.8561 33.6592 10.8895 33.8513 10.94 34.0379C10.9793 34.1954 11.0582 34.3361 11.1667 34.4423C11.2876 34.5498 11.4384 34.6031 11.591 34.5924C11.7592 34.6036 11.9247 34.5401 12.0535 34.4152C12.1135 34.3394 12.1592 34.25 12.1876 34.1527C12.216 34.0555 12.2265 33.9525 12.2185 33.8503C12.2219 33.6428 12.1714 33.4388 12.0734 33.2645C11.9571 33.0736 11.8227 32.8981 11.6726 32.7413L10.8892 31.8741C10.761 31.7352 10.656 31.5706 10.5791 31.3884C10.5126 31.2158 10.4792 31.0289 10.4812 30.8401C10.4727 30.6891 10.493 30.5378 10.5406 30.3966C10.5882 30.2555 10.662 30.128 10.7568 30.023C10.9589 29.8266 11.2178 29.7247 11.4822 29.7374C11.6266 29.7357 11.7703 29.7596 11.9084 29.8083C12.0315 29.8516 12.1436 29.9288 12.2348 30.0334C12.3301 30.1482 12.4025 30.2855 12.447 30.4357C12.5028 30.6303 12.5381 30.8319 12.5522 31.0361L12.1895 31.1445C12.1791 30.9561 12.1487 30.7699 12.0988 30.59C12.0611 30.4498 11.9855 30.3272 11.883 30.2398C11.7627 30.1513 11.6211 30.109 11.4786 30.1189C11.3158 30.1105 11.1558 30.1689 11.027 30.2836C10.9646 30.3473 10.9157 30.4267 10.8843 30.5156C10.8529 30.6046 10.8396 30.7006 10.8457 30.7964C10.8442 30.9271 10.8678 31.0566 10.9146 31.1758C10.9823 31.3177 11.072 31.4441 11.1794 31.5489L11.9664 32.4036C12.1416 32.589 12.2958 32.7992 12.4252 33.029C12.5537 33.2643 12.6204 33.5371 12.6175 33.8149C12.6242 34.0397 12.5791 34.2627 12.4869 34.4611C12.4041 34.6312 12.2774 34.7674 12.1242 34.8509C11.9581 34.941 11.7764 34.9867 11.5928 34.9843Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1758 34.9214V29.7891H14.7898V30.1622H13.6001V32.0884H14.5704V32.4428H13.6001V34.5586H14.8025V34.9214H13.1758Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.374 34.9212V29.7889H16.3823C16.6095 29.7763 16.8359 29.8293 17.0406 29.9432C17.1973 30.043 17.3191 30.2021 17.3852 30.3935C17.4599 30.6168 17.4956 30.8548 17.4904 31.0939C17.4915 31.2752 17.4727 31.4559 17.4341 31.6317C17.4041 31.79 17.342 31.9378 17.2528 32.0632C17.1547 32.1883 17.0221 32.2707 16.8774 32.2967L17.5611 34.9212H17.1531L16.4984 32.3989H15.7857V34.9212H15.374ZM15.7857 32.0445H16.3533C16.5042 32.0544 16.6547 32.0169 16.7885 31.9361C16.8922 31.864 16.9701 31.7516 17.008 31.6192C17.057 31.45 17.0797 31.2722 17.0751 31.0939C17.0905 30.8458 17.0406 30.5981 16.9318 30.3831C16.8357 30.2267 16.6471 30.1496 16.3642 30.1496H15.7857V32.0445Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.207 34.9214V29.7891H18.6259V34.9214H18.207Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2075 34.9214L19.1611 29.7891H19.5637L20.407 34.05L21.1995 29.7995H21.5894L20.5811 34.9318L20.2075 34.9214Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1338 34.9214V29.7891H22.5527V34.9214H22.1338Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3752 34.9843C24.1295 35.0043 23.8848 34.9311 23.6788 34.7758C23.5135 34.6306 23.3944 34.427 23.3397 34.1963C23.2742 33.9334 23.2424 33.6609 23.2454 33.3875V31.3404C23.2419 31.0585 23.2742 30.7776 23.3415 30.5065C23.3984 30.2799 23.5197 30.0817 23.6861 29.9437C23.8913 29.7935 24.1322 29.7206 24.3752 29.7352C24.5961 29.7219 24.8156 29.7835 25.0063 29.9124C25.1605 30.035 25.2758 30.2121 25.3345 30.4169C25.4046 30.6673 25.4383 30.9293 25.4343 31.1924V31.503H25.0353V31.207C25.0376 31.0131 25.0218 30.8195 24.9881 30.6295C24.9653 30.4831 24.8978 30.3508 24.7977 30.2564C24.6736 30.1576 24.5239 30.1105 24.3734 30.123C24.2138 30.1104 24.0553 30.1604 23.9236 30.2647C23.8188 30.3691 23.7473 30.5107 23.7205 30.667C23.6836 30.865 23.6659 31.0671 23.6679 31.2695V33.4562C23.6647 33.667 23.6861 33.8774 23.7314 34.0816C23.7619 34.2352 23.8382 34.3717 23.9472 34.4673C24.0738 34.559 24.2221 34.6034 24.3715 34.5944C24.5228 34.6061 24.6729 34.5567 24.7959 34.4548C24.896 34.3534 24.9632 34.216 24.9863 34.065C25.0196 33.8721 25.0354 33.6758 25.0335 33.4792V33.1436H25.4306V33.4479C25.434 33.7178 25.4029 33.9868 25.3381 34.2463C25.2875 34.4624 25.1751 34.6526 25.019 34.7862C24.828 34.9289 24.6026 34.9983 24.3752 34.9843Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.084 34.9214V29.7891H27.6998V30.1622H26.5083V32.0884H27.4786V32.4428H26.5083V34.5586H27.7107V34.9214H26.084Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.802 58.4756H67.5168C67.5168 58.4756 62.2577 73.3409 63.2497 79.9804H53.4043C53.4043 79.9804 55.2414 63.0033 57.802 58.4756Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3962 37.1378C49.3962 37.1378 49.4923 39.1494 52.7511 40.323C56.0099 41.4967 59.3177 40.323 61.1657 41.9907C63.0136 43.6584 62.9647 46.2392 62.3317 47.5254C61.6988 48.8116 60.6779 50.0957 63.6937 51.6049C66.7095 53.1142 64.9087 57.5315 63.6447 59.1533C62.3807 60.7751 60.1991 61.5568 57.76 60.9981C55.3208 60.4395 52.4591 53.6749 49.3472 50.0957C46.2352 46.5164 45.8544 39.9145 47.8402 38.0216C49.826 36.1288 49.3962 37.1378 49.3962 37.1378Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8953 29.902C48.8953 29.902 50.2373 29.2287 50.5819 30.5274C50.9264 31.8261 51.028 35.395 51.028 35.395L50.3026 35.1969C50.3026 35.1969 50.4749 31.1611 49.6824 30.5274C48.8899 29.8937 48.2715 31.3196 48.2715 31.3196L48.8953 29.902Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8311 73.3203L38.4155 70.5019C38.4155 70.5019 38.0982 64.9715 38.1435 64.763C38.1889 64.5546 39.3368 53.7334 39.3368 53.7334L36.1922 64.4503L33.8311 73.3203Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0986 48.1757C54.0986 48.1757 58.6323 51.015 59.2416 51.3026C59.8509 51.5903 59.4919 55.2113 59.4919 57.5773C59.4919 59.9433 56.4089 79.9242 56.4089 79.9242H33.5771C33.5771 79.9242 37.4344 73.1264 37.5378 71.3524C37.6412 69.5784 36.972 68.1587 36.8686 66.4452C36.7653 64.7316 38.9777 54.2649 39.3368 53.7291C39.6958 53.1934 41.2409 51.8384 41.2409 51.8384L46.6923 46.3496L49.213 45.6992L54.0986 48.1757Z",
    fill: "#4A3163",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9658 73.2744L38.2041 75.0755",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6988 68.1006C39.6988 68.1006 38.5672 68.9865 39.133 69.4597C39.6988 69.933 39.9564 70.9377 39.9564 70.9377L39.231 72.5616",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0283 72.4072C45.3348 72.4343 45.6576 72.4552 45.9949 72.4656",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1582 70.9482C40.1582 70.9482 41.3896 71.8947 44.0717 72.2991",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0915 33.1456C36.8746 33.2673 36.6938 33.4597 36.5716 33.6989C36.4493 33.938 36.3911 34.2132 36.4041 34.4902C36.4041 35.52 37.1295 37.5358 37.1295 37.5358L37.543 37.3795C37.543 37.3795 36.7868 35.2823 36.8902 34.5298C36.9237 34.3104 37.0091 34.1058 37.137 33.9385C37.265 33.7712 37.4305 33.6476 37.6156 33.5813L37.4777 33.0664L37.0915 33.1456Z",
    fill: "#A6A6A6",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8625 38.4432C39.0438 39.4855 38.7337 40.4256 38.1824 40.5486C37.6311 40.6716 37.0436 39.9233 36.8695 38.881C36.6954 37.8387 36.9982 36.8964 37.5495 36.7755C38.1008 36.6546 38.6884 37.403 38.8625 38.4432Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5351 38.1068C40.8778 39.4368 40.477 40.748 39.6392 41.0252C38.8014 41.3025 37.8438 40.4645 37.4993 39.1345C37.1547 37.8045 37.5573 36.4933 38.3951 36.216C39.233 35.9388 40.1923 36.7768 40.5351 38.1068Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6428 45.3572L44.457 48.4007L41.7803 52.2781L41.3342 55.2736C41.3342 55.2736 40.8899 63.8205 41.1438 65.138C41.3977 66.4555 41.3977 66.8182 41.3977 66.8182C41.3977 66.8182 46.9288 59.4387 49.6617 54.9088C52.3947 50.379 53.0294 47.6002 53.0294 47.6002L50.3599 45.9325L49.0905 39.1367L43.6428 45.3572Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8637 42.4121L44.4561 48.4012L43.5059 44.8761L47.8637 42.4121Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3567 55.1048L41.3313 55.2736C41.3313 55.2736 40.887 63.8205 41.1409 65.138C41.3947 66.4555 41.3948 66.8182 41.3948 66.8182C41.3948 66.8182 46.9259 59.4387 49.6588 54.9088C49.8728 54.5545 50.0723 54.2105 50.2627 53.877C46.8406 55.2236 43.3515 55.2465 41.3567 55.1048Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0179 26.6983C40.0179 26.6983 37.47 28.4785 37.1943 31.1676C36.9187 33.8568 37.8834 36.746 38.2625 37.8926C38.6415 39.0391 39.949 43.5106 40.6363 44.382C41.3236 45.2533 43.5615 46.5562 43.9405 46.7938C44.3195 47.0315 45.0068 46.9523 45.5926 46.477C46.1783 46.0017 48.5866 42.6413 48.9657 41.8492C49.3447 41.057 49.4118 39.3164 49.4118 39.3164C49.4118 39.3164 49.3429 35.8351 49.2069 33.5816C49.0708 31.3282 49.1724 29.1498 47.5548 27.2507C45.9371 25.3516 41.6011 25.312 40.0179 26.6983Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2065 33.5816C49.0687 31.3261 49.172 29.1497 47.5544 27.2507C45.9368 25.3516 41.6007 25.312 40.0176 26.6983C40.0176 26.6983 37.4696 28.4785 37.194 31.1676C37.0344 32.7311 37.2937 34.3571 37.6111 35.6746C38.1968 35.2576 40.1735 33.8651 42.3914 32.0786C45.0409 29.9419 45.9023 26.619 45.9023 26.619C45.9023 26.619 46.2106 26.421 46.1435 26.8567C46.0764 27.2924 45.0409 29.8627 44.6637 30.2588L44.2847 30.6527C44.2847 30.6527 44.5948 30.5735 46.0057 32.5122C47.4166 34.4509 48.2073 35.243 48.6207 35.4807C48.8404 35.5719 49.071 35.6233 49.3044 35.6329C49.2772 34.922 49.2446 34.2049 49.2065 33.5816Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9684 37.7752C45.012 38.065 44.9195 38.3276 44.7599 38.3589C44.6003 38.3902 44.4371 38.1817 44.3972 37.892C44.3573 37.6022 44.4462 37.3395 44.6057 37.3062C44.7653 37.2728 44.9231 37.4855 44.9684 37.7752Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1116 38.4079C41.157 38.6998 41.0645 38.9603 40.9049 38.9937C40.7453 39.0271 40.5803 38.8165 40.5422 38.5247C40.5041 38.2328 40.5894 37.9743 40.749 37.941C40.9085 37.9076 41.0681 38.1182 41.1116 38.4079Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3887 35.9933C43.3887 35.9933 44.5257 34.9656 45.5649 35.7953",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0838 36.5524C41.0838 36.5524 39.7418 35.7999 38.8115 37.1465",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3252 36.5879C41.3252 36.5879 42.2537 37.1028 42.3226 38.0909",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3564 40.8213C42.3564 40.8213 42.7355 41.1361 43.3883 40.9005",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M42.082 42.4827C42.8534 42.4445 43.612 42.2431 44.3199 41.8886C45.524 41.2945 46.0064 40.4648 46.0064 40.4648",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.666 42.4431C42.9412 42.7229 43.296 42.8771 43.6634 42.8767C44.2836 42.8767 44.8331 41.6113 44.8331 41.6113C44.8331 41.6113 43.25 42.4035 42.666 42.4431Z",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8234 39.5141C50.6978 39.5141 51.4066 38.3895 51.4066 37.0022C51.4066 35.6149 50.6978 34.4902 49.8234 34.4902C48.949 34.4902 48.2402 35.6149 48.2402 37.0022C48.2402 38.3895 48.949 39.5141 49.8234 39.5141Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M50.496 38.487C51.0569 38.487 51.5116 37.6284 51.5116 36.5692C51.5116 35.51 51.0569 34.6514 50.496 34.6514C49.9351 34.6514 49.4805 35.51 49.4805 36.5692C49.4805 37.6284 49.9351 38.487 50.496 38.487Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1816 39.6797C38.1816 39.6797 38.1925 43.7905 39.121 44.147C40.0495 44.5035 42.5975 43.7905 42.5975 43.7905",
    stroke: "#263238",
    strokeWidth: 1.50284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9049 43.7735C43.9049 44.0903 43.5658 44.3467 43.1468 44.3467C42.7279 44.3467 42.3906 44.0903 42.3906 43.7735C42.3906 43.4566 42.7297 43.2002 43.1468 43.2002C43.5639 43.2002 43.9049 43.4566 43.9049 43.7735Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1205 48.5908C44.1205 48.5908 43.0324 50.7776 42.2689 57.2815C41.5054 63.7855 42.0114 65.0842 42.0114 65.0842L40.9233 65.8534C40.9233 65.8534 38.6619 65.5574 39.4326 59.4099C40.2033 53.2624 40.6313 52.2556 40.6313 52.2556L44.1205 48.5908Z",
    fill: "#4A3163",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M51.012 46.3496C51.012 46.3496 48.5439 53.0891 45.9724 57.2875C43.4008 61.4859 39.9062 67.5083 39.9062 67.5083C39.9062 67.5083 41.7578 66.5036 45.6677 63.1307C49.5776 59.7578 53.5364 52.0156 53.9481 51.2484C54.3597 50.4813 54.9763 48.7073 54.9763 48.7073L51.012 46.3496Z",
    fill: "#4A3163",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6477 76.2936C29.0444 76.7157 28.4118 77.0796 27.7563 77.3818C26.5993 77.9258 26.4868 77.83 26.8622 78.2886C27.2376 78.7472 29.1762 77.9258 29.7022 77.684C30.2281 77.4422 31.2273 77.0795 31.2273 77.0795C31.2273 77.0795 32.4369 77.8654 33.1732 78.1072C33.9094 78.349 34.8053 77.9863 34.8053 77.9863C34.8053 77.9863 34.8579 77.019 34.2268 76.475C33.5957 75.9309 32.232 74.6614 31.755 74.7218C31.2781 74.7823 29.6477 76.2936 29.6477 76.2936Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3313 74.8422C29.3313 74.8422 28.7002 74.6609 28.2794 75.0236C27.8587 75.3863 27.3854 76.5349 27.3328 76.8372C27.2802 77.1395 27.3854 77.3208 27.8061 76.8976C28.2269 76.4745 28.9631 75.8699 28.9631 75.8699L29.5942 75.6281L29.3313 74.8422Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9629 74.2985C30.9629 74.2985 29.6934 73.8149 29.4377 74.238C29.182 74.6612 28.2807 77.0794 28.5437 77.2607C28.8066 77.4421 29.1748 77.0794 29.6481 76.2935C30.1214 75.5076 30.3844 75.0844 30.3844 75.0844L31.0154 74.9635L30.9629 74.2985Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2173 74.8406C33.2173 74.8406 31.5725 73.3626 31.1608 73.717C30.7491 74.0714 29.4126 76.3769 29.2585 76.8439C29.1043 77.3108 29.8243 77.0815 30.3883 76.4895C30.9523 75.8975 31.6232 75.2387 31.6232 75.2387L32.909 76.008L33.2173 74.8406Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M39.133 75.9635C39.133 75.9635 36.9731 75.8446 36.099 75.4903C35.2249 75.1359 33.4749 74.3667 32.9617 74.425C32.4485 74.4834 30.4917 76.6722 30.0801 77.1454C29.6684 77.6186 29.7174 77.7458 30.1218 77.8042C30.5262 77.8625 31.52 77.0871 31.9842 76.6722C32.2714 76.4181 32.5815 76.2001 32.9091 76.0218C33.2782 76.6324 33.6914 77.2063 34.1441 77.7375C34.6573 78.269 35.8923 78.6818 36.3547 78.6234C36.649 78.5849 36.9409 78.5257 37.2288 78.4462L38.9788 78.3879L39.133 75.9635Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1494 58.876C54.1494 58.876 52.2471 61.4171 52.3504 62.3052C52.4538 63.1932 52.5046 64.0771 52.5046 64.0771L51.1155 73.7142C51.1155 73.7142 49.9331 73.0638 49.9331 73.5954V74.129L38.8182 75.4298L38.7148 79.9222L56.4072 79.9805C56.4072 79.9805 57.2813 78.859 57.3847 78.4442C57.488 78.0293 59.4412 70.8771 59.9562 63.3683C60.4712 55.8596 60.2137 52.4909 59.9562 51.903C59.6987 51.3151 56.6647 50.1895 56.6647 50.1895",
    fill: "#4A3163"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1494 58.876C54.1494 58.876 52.2471 61.4171 52.3504 62.3052C52.4538 63.1932 52.5046 64.0771 52.5046 64.0771L51.1155 73.7142C51.1155 73.7142 49.9331 73.0638 49.9331 73.5954V74.129L38.8182 75.4298L38.7148 79.9222L56.4072 79.9805C56.4072 79.9805 57.2813 78.859 57.3847 78.4442C57.488 78.0293 59.4412 70.8771 59.9562 63.3683C60.4712 55.8596 60.2137 52.4909 59.9562 51.903C59.6987 51.3151 56.6647 50.1895 56.6647 50.1895",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5283 73.6582C51.5283 73.6582 53.1732 74.8985 54.1506 75.1946L51.5283 73.6582Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5283 73.6582C51.5283 73.6582 53.1732 74.8985 54.1506 75.1946",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0986 61.6649L37.3681 56.9808C37.8828 56.401 38.3335 55.7506 38.71 55.0442C39.2541 53.9873 39.2541 52.0049 39.1689 51.6526C39.0836 51.3003 40.2805 49.716 40.6196 49.151C40.9588 48.5861 41.1546 47.5647 40.6958 46.8163C40.237 46.0679 40.0067 47.302 39.7002 47.8732C39.3937 48.4444 38.3201 49.0176 38.3201 49.0176L37.1867 50.0766C37.1867 50.0766 35.3098 51.9694 35.1919 52.2342C35.074 52.4989 34.8473 53.3348 34.8473 53.3348L35.0015 55.8885L34.0059 60.3349L36.0986 61.6649Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4111 48.5366C36.4111 48.5366 37.3306 46.869 37.599 46.3353C37.8674 45.8016 38.2881 43.6941 38.5565 43.8338C38.8249 43.9734 39.1005 44.6676 39.0171 45.5953C38.9337 46.5229 37.9816 48.6325 37.9816 48.6325L36.4111 48.5366Z",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1904 59.0157L34.9956 55.8888L34.6474 50.869L35.7192 48.4926L38.6679 48.0527C38.6679 48.0527 40.4687 49.1534 40.6229 49.1534C40.777 49.1534 40.6229 49.637 40.2783 49.7246C39.9337 49.8121 39.2809 49.5933 39.2809 49.5933L40.3925 50.4271C40.3925 50.4271 40.3164 50.8232 40.048 50.9107C39.783 50.9722 39.5132 51.0022 39.2428 51.0004C39.2428 51.0004 40.2003 51.705 39.9682 51.8342C39.7408 51.9542 39.4929 52.014 39.2428 52.0093H38.5174L37.9425 51.9218L37.0612 52.3178C37.0612 52.3178 37.6741 54.1231 37.6361 55.0049C37.598 55.8867 36.6405 56.4641 36.6405 56.4641",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1904 59.0157L34.9956 55.8888L34.6474 50.869L35.7192 48.4926L38.6679 48.0527C38.6679 48.0527 40.4687 49.1534 40.6229 49.1534C40.777 49.1534 40.6229 49.637 40.2783 49.7246C39.9337 49.8121 39.2809 49.5933 39.2809 49.5933L40.3925 50.4271C40.3925 50.4271 40.3164 50.8232 40.048 50.9107C39.783 50.9722 39.5132 51.0022 39.2428 51.0004C39.2428 51.0004 40.2003 51.705 39.9682 51.8342C39.7408 51.9542 39.4929 52.014 39.2428 52.0093H38.5174L37.9425 51.9218L37.0612 52.3178C37.0612 52.3178 37.6741 54.1231 37.6361 55.0049C37.598 55.8867 36.6405 56.4641 36.6405 56.4641",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2855 49.5928C39.2855 49.5928 38.6725 49.0195 38.3279 49.0195C37.9834 49.0195 35.8779 49.4594 35.8779 49.4594",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2469 51.0023C39.2469 51.0023 38.2513 50.377 37.9448 50.377C37.6384 50.377 35.2246 51.0816 35.2246 51.0816",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2389 58.0342L37.349 60.4419C37.349 60.4419 35.9635 68.9888 35.8275 69.7205C35.6915 70.4522 34.694 72.3804 34.1953 72.9558C33.6966 73.5311 33.1072 73.4248 31.7453 73.0079C30.3834 72.591 29.2064 71.3402 29.2481 69.7205C29.2899 68.1007 34.2389 58.0342 34.2389 58.0342Z",
    fill: "#4A3163",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1639 78.75H17.2607V79.0689H18.1639V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4148 78.75H18.5117V79.0689H19.4148V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6658 78.75H19.7627V79.0689H20.6658V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9178 78.75H21.0146V79.0689H21.9178V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1707 78.75H22.2676V79.0689H23.1707V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4207 78.75H23.5176V79.0689H24.4207V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6736 78.75H24.7705V79.0689H25.6736V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9236 78.75H26.0205V79.0689H26.9236V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1756 78.75H27.2725V79.0689H28.1756V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4275 78.75H28.5244V79.0689H29.4275V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6805 78.75H29.7773V79.0689H30.6805V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9314 78.75H31.0283V79.0689H31.9314V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1834 78.75H32.2803V79.0689H33.1834V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4334 78.75H33.5303V79.0689H34.4334V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6853 78.75H34.7822V79.0689H35.6853V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9373 78.75H36.0342V79.0689H36.9373V78.75Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1178 79.002H16.7412V79.9067H39.1178V79.002Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1159 79.002H30.5381V79.9067H39.1159V79.002Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7239 71.078H6.1313L2.59863 49.5732H20.1913L23.7239 71.078Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1894 70.5338H6.12267L2.76953 50.1172H19.8344L23.1894 70.5338Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9022 68.9085H7.21327L4.71973 53.7305H17.4087L19.9022 68.9085Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72084 53.7298L2.76953 50.1172",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4092 53.7298L19.8338 50.1172",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9023 68.9072L23.1884 70.5332",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21379 68.9072L6.12207 70.5332",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3742 64.362H9.48535L11.3242 62.4775H14.2131L12.3742 64.362Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9577 78.7744H11.3887V79.9814H21.9577V78.7744Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9196 79.9815H13.0307L9.48535 75.3516H12.3742L15.9196 79.9815Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3742 64.4385H9.48535V75.3034H12.3742V64.4385Z",
    fill: "#263238",
    stroke: "white",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6689 77.915C55.0816 78.7762 55.7087 79.4759 56.4697 79.9246L54.6689 77.915Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6689 77.915C55.0816 78.7762 55.7087 79.4759 56.4697 79.9246",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 79.9805H83.1158",
    stroke: "#263238",
    strokeWidth: 0.751421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon2);
export default __webpack_public_path__ + "static/media/profile_icon_2.8da547c8f7f13d06ba6ee71d14c99fc2.svg";
export { ForwardRef as ReactComponent };